<div class="wrapper">
	<div class="content">
		<div *ngIf="avatarUrl; else text" class="pic-wrapper">
			<img [src]="avatarUrl">
		</div>
		<ng-template #text>
			<div class="initials">{{initials}}</div>
		</ng-template>
	</div>
</div>
